import Vue from 'vue'
import Router from 'vue-router'
//import BlogIndex from '@/components/BlogIndex'
//import BlogDetail from '@/components/BlogDetail'
import Game from '@/components/game/Game'
import Time from '@/components/game/Time'
import Duration from '@/components/game/ChartTab'
import Lists from '@/components/game/Lists'
import FullScreen from '@/components/game/FullScreen'
import Work from '@/components/game/Work'
import WorkDetail from '@/components/game/WorkDetail'
import Gy from '@/components/game/Gy'
import Map from '@/components/game/Map'
import Chat from '@/components/game/shipin/Chat'

import Ground from '@/components/game/Ground'
import Gift from '@/components/game/Gift'

import Job from '@/components/game/works/Job'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/job',
      name: 'Job',
      component: Job
    },{
      path: '/gift',
      name: 'Gift',
      component: Gift
    },
    {
      path: '/map',
      name: 'Map',
      component: Map
    },
    {
      path: '/chat',
      name: 'Chat',
      component: Chat
    },
    {
      path: '/ground',
      name: 'Ground',
      component: Ground
    },
    {
      path: '/',
      name: 'Game',
      component: Game
    },
    {
      path: '/work',
      name: 'Work',
      component: Work
    },
    {
      path: '/gy',
      name: 'Gy',
      component: Gy
    },
    {
      path: '/detail',
      name: 'WorkDetail',
      component: WorkDetail
    },
    {
      path: '/full',
      name: 'FullScreen',
      component: FullScreen
    },
    {
      path: '/lists',
      name: 'Lists',
      component: Lists
    },
    {
      path: '/time',
      name: 'Time',
      component: Time
    },
    {
      path: '/dur',
      name: 'Duration',
      component: Duration
    }
    /*,
    {
      path: '/s',
      name: 'BlogIndex',
      component: BlogIndex
    },
    {
      path: '/detail/:id',
      name: 'BlogDetail',
      component: BlogDetail
    },
    {
      path: '/game',
      name: 'Game',
      component: Game
    }*/
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js